import {useQuery} from "react-query";
import {apiV2} from "../api/axiosConfig";
import {UserModel} from "../features/management-v2/users/types/UserModel";



async function getUser(id: string) {
    return (await apiV2.get<UserModel>(`users/${id}`)).data;
}

export function useGetUser(id: string) {
    const {data, isLoading, error} = useQuery<UserModel>({
        queryKey: ["user", id],
        queryFn: () => getUser(id),
        cacheTime: 300,
    })

    return {user: data, isLoading, error}
}